module.exports = __webpack_public_path__ + "img/shield-square.53e276da.svg";